import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'account_address'

  static get fields () {
    return {
      id: new UUID(),
      code: new STRING(),
      name: new STRING(),
      line_one: new STRING(),
      line_two: new STRING(),
      suburb: new STRING(),
      postcode: new STRING(),
      state: new STRING(),
      country: new STRING(),
      contact: new STRING(),
      phone: new STRING(),
      email: new STRING(),
      spi: new STRING(),
      rtp_account: new STRING(),
      type: new BOOLEAN(),
      atl: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      carrier_service: new ITEM(CarrierService)
    }
  }

  static get sortables () {
    return [
      { field: 'code', label: 'Code' },
      { field: 'name', label: 'Name' },
      { field: 'line_one', label: 'Line One' },
      { field: 'line_two', label: 'Line Two' },
      { field: 'suburb', label: 'Suburb' },
      { field: 'postcode', label: 'Postcode' },
      { field: 'state', label: 'State' },
      { field: 'country', label: 'Country' },
      { field: 'contact', label: 'Contact' },
      { field: 'phone', label: 'Phone' },
      { field: 'email', label: 'Email' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' }
    ]
  }
}
